import { push } from "connected-react-router";

const importTours = () => {
  return push(`/tours/import`);
};

export const gotoImportTours = {
  importTours: importTours,
};
